import constate from 'constate'
import { useBoolean } from 'hooks/use-boolean'

export const [IsWaitingToAddCardProvider, useIsWaitingToAddCard] = constate(
  () => useBoolean(false),
)
